import { render } from "./TransfertArgent.vue?vue&type=template&id=444bba8d&ts=true"
import script from "./TransfertArgent.vue?vue&type=script&lang=ts"
export * from "./TransfertArgent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__